import {getToken} from '@/utils/cookieUtil'
import {ssoValidate} from '@/api'

/**
 * SSO跳转到admin后台
 * @param {string} adminUrl admin后台地址
 */
export function jumpToAdmin(adminUrl) {
  try {
    var token = getToken()
    if (!token) {
      throw new Error('用户未登录')
    }
    
    // 验证SSO token
    ssoValidate({
      token: token,
      targetApp: 'admin',
      timestamp: Date.now()
    }).then(function(response) {
      if (response.code === 200) {
        // 构建跳转URL，使用传入的adminUrl或默认地址
        var defaultAdminUrl = process.env.VUE_APP_ADMIN_API || 'http://www.xuanzhuoblog.cn/admin'
        var finalAdminUrl = adminUrl || defaultAdminUrl
        // 传递web端的token，让admin端进行验证
        var jumpUrl = finalAdminUrl + '?sso_token=' + token
        window.open(jumpUrl, '_blank')
      } else {
        throw new Error(response.message || 'SSO验证失败')
      }
    }).catch(function(error) {
      console.error('SSO跳转失败:', error)
      throw error
    })
  } catch (error) {
    console.error('SSO跳转失败:', error)
    throw error
  }
}

/**
 * 检查用户是否有admin权限
 * @param {Object} userInfo 用户信息
 * @returns {boolean}
 */
export function hasAdminPermission(userInfo) {
    // 这里可以根据实际业务逻辑判断用户是否有admin权限
    // 比如检查用户角色、用户ID等
    return userInfo && (userInfo.id === 1 || userInfo.role === 'admin')
}